import { Component, OnInit, AfterViewInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CookieService } from 'angular2-cookie/core';
import { CardHttpService } from './../../core/http/internal/card.http.service';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { EcommerceComponent } from '../../shared/ecommerce/ecommerce';
import { Product } from '../../shared/ecommerce/models/ecommerceProduct';
import { CategoryTypes } from '../../shared/ecommerce/enums/categoryTypes';
import { TransactionTypes } from '../../shared/ecommerce/enums/transactionTypes';

@Component({
    selector: 'card-activate-app',
    template: require('./card-activate.component.html'),
    providers: [CardHttpService],
})

export class CardActivateComponent implements OnInit, AfterViewInit {

    accessCardId: string;
    token: string;
    clientId: string;

    activationResult: boolean; //true or false activation result after resolving
    activationStatus = false; //initial status false

    model = new CardActivateFormData();

    constructor(
        private readonly cookieService: CookieService,
        public vcRef: ViewContainerRef,
        private readonly cardService: CardHttpService,
        private readonly titleService: Title,
        private readonly toastr: ToastrService,
        private readonly route: ActivatedRoute
    ) {
    }

    ngOnInit(): void {
        this.accessCardId = this.route.snapshot.queryParams['accessCardId'];
        this.token = this.route.snapshot.queryParams['token'];
        this.clientId = this.route.snapshot.queryParams['clientId'];
    }

    async ngAfterViewInit() {
        try {
            this.model.accessCardId = this.accessCardId;
            this.model.token = this.token;
            this.model.clientId = this.clientId;

            this.cardService.postCardActivate(this.model).subscribe(async result => {
                if ('undefined' !== typeof result.errors && result.errors.length > 0) {
                    this.activationStatus = true;
                    this.activationResult = false;
                    this.toastr.error(`Ошибка при активации карты! ${result.errors[0].toString()}`);
                } else {
                    this.activationResult = true;
                    //this.cookieService.put('bd569aa34a4d901e228d4272197d4bb3', 'true') set default parent lock
                    const term = `${result.result.packagePrice.term.quantity}${result.result.packagePrice.term.period}`;

                    if (result.result.transactionId) {
                        this.processEcommerce(
                            result.result.activatedClient, result.result.transactionId, term, result.result.packagePrice);
                    }

                    try {
                        const object = {
                            'event': 'accesscard',
                            'cardActivationCode': result.result.cardActivationCode,
                            'subscriptionType': term,
                            'eventCallback': function () {
                                window.location.replace('/registration/success');
                            }
                        };
                        (window as any)['dataLayer'].push(object);
                    } catch (e) {
                        window.location.replace('/registration/success');
                    }
                }
            },
                async err => {
                    this.activationResult = false;
                    this.activationStatus = true;
                    this.toastr.error(`Ошибка при активации карты! ${err.toString()}`);
                });
        } catch (err) {
            this.activationResult = false;
            this.activationStatus = true;
            this.toastr.error(`Ошибка при активации карты! ${err.toString()}`);
        }
    }

    processEcommerce(client: any, transactionId: string, term: string, packagePrice: any) {
        let ecommerceComponent = new EcommerceComponent();
        ecommerceComponent = ecommerceComponent
            .setPromo('')
            .setDebug((client.firstName === 'John' && client.lastName === 'Rambo'))
            .setClient({
                firstName: client.firstName,
                lastName: client.lastName,
                provinceName: client.billingAddress.countryRegion.name,
                countryName: client.billingAddress.countryRegion.country.name,
                isLegacy: false,
                readableId: client.readableId,
                shippingCountry: null,
                id: client.readableId
            })
            .setTransaction(transactionId)
            .setCustomerNew();

        const product = new Product()
            .setName(`${packagePrice.package.name} (${packagePrice.packagePriceTypeName})`)
            .setId(`prepaid_${packagePrice.id}`)
            .setPrice(0)
            .setTerm(term)
            .setCategory(CategoryTypes.AccessCard);

        const isTrial = packagePrice.term.weekly;

        ecommerceComponent.addProduct(product, 1);
        ecommerceComponent.send(isTrial, TransactionTypes.CardActivation);
    }
}

class CardActivateFormData {
    public accessCardId: string;
    public token: string;
    public clientId: string;
}


// WEBPACK FOOTER //
// ./src/app/card/components/card-activate.component.ts